import api from '../../../services/api';
import type { 
  Task, 
  CreateTaskRequest, 
  UpdateTaskRequest,
  TaskOrderUpdate,
  TaskType,
  TaskComment,
  CommentKind
} from '../../../types';

export const taskService = {
  async getTasks(workspace?: 'personal' | 'team', teamId?: string): Promise<Task[]> {
    const params = new URLSearchParams();
    if (workspace) {
      params.append('workspace', workspace);
    }
    if (teamId) {
      params.append('teamId', teamId);
    }
    
    const response = await api.get(`/tasks/all?${params.toString()}`);
    return response.data;
  },

  async getTaskTypes(): Promise<TaskType[]> {
    const response = await api.get('/task-types');
    return response.data;
  },

  async createTask(task: CreateTaskRequest, workspace?: 'personal' | 'team', teamId?: string): Promise<Task> {
    const params = new URLSearchParams();
    if (workspace) {
      params.append('workspace', workspace);
    }
    if (teamId) {
      params.append('teamId', teamId);
    }
    
    const response = await api.post(`/tasks?${params.toString()}`, task);
    return response.data;
  },

  async updateTask(id: string, updates: UpdateTaskRequest): Promise<Task> {
    const response = await api.patch(`/tasks/${id}`, updates);
    return response.data;
  },

  async getComments(taskId: string): Promise<TaskComment[]> {
    const response = await api.get(`/tasks/${taskId}/comments`);
    return response.data;
  },

  async addComment(taskId: string, content: string, kind?: CommentKind): Promise<TaskComment> {
    const response = await api.post(`/tasks/${taskId}/comments`, { content, kind });
    return response.data;
  },

  async deleteTask(id: string): Promise<void> {
    await api.delete(`/tasks/${id}`);
  },

  async reorderTasks(updates: TaskOrderUpdate[]): Promise<void> {
    // 转换为后端期望的格式
    const reorderData = updates.map(update => ({
      id: update.taskId,
      order: update.newOrder
    }));
    
    await api.post('/tasks/reorder', reorderData);
  }
};